import type { PeperoLabelFlavor, PeperoLabelType } from '@/store/server/common/pepero-label/pepero-label.dto';

// 빼빼로 6종 — 키는 BE `flavor` 값이자 /create/photo?flavor= 쿼리 값.
// 표시 순서는 M02 빼빼로 종류 선택 화면(2열 × 3행) 순서를 따른다.
export const PEPERO_LABEL_FLAVOR_NAME = {
  original: '오리지널',
  almond: '아몬드',
  'choco-filled': '초코필드',
  crunky: '크런키',
  'white-cookie': '화이트쿠키',
  strawberry: '스트로베리',
} as const satisfies Record<PeperoLabelFlavor, string>;

export const PEPERO_LABEL_FLAVORS = Object.keys(PEPERO_LABEL_FLAVOR_NAME) as PeperoLabelFlavor[];

export const PEPERO_LABEL_TYPE_NAME = {
  photo: '사진 커스텀',
  text: '문구 커스텀',
} as const satisfies Record<PeperoLabelType, string>;

/**
 * 현장 무료 인쇄 한도 — 행사 전체·모든 라벨 합산 계정당 (SB 운영 정책 11). 3회 → 10회 (2026-10-29) → 3회 (2026-10-30)
 * API 는 사용 횟수(use_cnt)만 주고 한도는 주지 않는다 — BE 한도와 함께 바꾼다. 안내 문구도 이 값을 쓴다.
 */
export const PEPERO_LABEL_PRINT_LIMIT = 3;

/**
 * 계정 전체 남은 인쇄 횟수. 서버가 동시 출력으로 한도를 넘겨 셀 수 있어 0 아래로 내리지 않는다.
 * 화면에서 직접 1을 빼지 말고 항상 GET /pepero-label/code/use 의 use_cnt 로 계산한다.
 */
export const getRemainingPrintCount = (useCount: number) => Math.max(0, PEPERO_LABEL_PRINT_LIMIT - useCount);

// 쿼리 파라미터 등 외부 입력을 flavor 로 좁힌다. 모르는 값이면 null → 호출부에서 M02 로 돌려보낸다.
export const parsePeperoLabelFlavor = (value: string | null | undefined): PeperoLabelFlavor | null => {
  if (!value) return null;
  // in 은 toString·constructor 같은 상속 키도 통과시킨다
  return Object.hasOwn(PEPERO_LABEL_FLAVOR_NAME, value) ? (value as PeperoLabelFlavor) : null;
};
